import { Button } from '@mui/material'
import styles from './PropertySpyNotAdded.module.css'
import { Link } from 'react-router-dom'

export const PropertySpyNotAdded = (): JSX.Element => {
    return (
        <div>
            <h3 className={styles.PropertySpyNotAdded__Heading1}>No Properties Added</h3>
            <div className={styles.PropertySpyNotAdded__Description}>
                To start monitoring your competitors, browse the map and add rental listings
                you want to track. We'll send you notifications about any changes.
            </div>
            <div className={styles.HostServiceCard__ButtonContainer}>
                <Link to="/competitors">
                    <Button
                        className={styles.HostServiceCard__Button}
                        color="success"
                        variant="contained"
                        sx={{
                            fontSize: '20px',
                            textTransform: 'none',
                            width: 410
                        }}
                    >
                        Add First Property
                    </Button >
                </Link>
            </div>
        </div> 
    )
}